import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export const CartDrawer = () => {
  const { items, open, setOpen, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  const goCheckout = () => {
    setOpen(false);
    navigate("/cart");
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="w-full sm:max-w-md flex flex-col p-0" data-testid="cart-drawer">
        <SheetHeader className="px-6 pt-6 pb-4 border-b">
          <SheetTitle className="font-display text-2xl text-brand-navy">Your Cart</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
          {items.length === 0 && (
            <p className="text-brand-navy/50 text-sm py-12 text-center" data-testid="cart-empty">Your cart is empty.</p>
          )}
          {items.map((i) => (
            <div key={i.slug} className="flex gap-4 border-b border-brand-navy/10 pb-4" data-testid={`cart-item-${i.slug}`}>
              <img src={i.image} alt={i.name} className="h-20 w-20 rounded-lg object-cover bg-brand-mist" />
              <div className="flex-1">
                <p className="font-semibold text-sm text-brand-navy leading-snug">{i.name}</p>
                <p className="text-brand-blue font-bold mt-1">${i.price.toFixed(2)}</p>
                <div className="flex items-center gap-3 mt-2">
                  <div className="flex items-center border border-brand-navy/15 rounded-full">
                    <button onClick={() => updateQty(i.slug, i.quantity - 1)} className="p-1.5" data-testid={`decrease-${i.slug}`}><Minus className="h-3.5 w-3.5" /></button>
                    <span className="w-6 text-center text-sm font-semibold">{i.quantity}</span>
                    <button onClick={() => updateQty(i.slug, i.quantity + 1)} className="p-1.5" data-testid={`increase-${i.slug}`}><Plus className="h-3.5 w-3.5" /></button>
                  </div>
                  <button onClick={() => removeItem(i.slug)} className="text-brand-navy/40 hover:text-destructive transition-colors" data-testid={`remove-${i.slug}`}>
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t px-6 py-5 space-y-4">
            <div className="flex justify-between items-center">
              <span className="font-mono-label text-xs uppercase tracking-[0.15em] text-brand-navy/60">Subtotal</span>
              <span className="font-display text-2xl text-brand-navy" data-testid="cart-subtotal">${subtotal.toFixed(2)}</span>
            </div>
            <Button onClick={goCheckout} data-testid="cart-checkout-button" className="w-full rounded-full bg-brand-navy hover:bg-brand-blue text-white h-12 text-base">
              Checkout
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
